<template>
  <div v-on:click="checkExpiry()" v-on:keydown="checkExpiry()" v-on:touchstart="checkExpiry()" v-on:scroll="checkExpiry()">
    <div v-if="product === 'PocketPhone'" class="number__choose">
      <div
        class="chooseNumber"
        @click="chooseNumber"
        :class="{ 'chooseNumber--active': showNumberConfig }"
      >
        <span>I want to choose my number.</span>
      </div>

      <div
        class="keepNumber"
        @click="keepNumber"
        :class="{ 'chooseNumber--active': keepExisting }"
      >
        <span>I want to keep my existing number.</span>
      </div>
    </div>

    <previously-selected
      v-if="product === 'PocketPhone'"
      v-show="!expired && previouslySelectedFormatted && showNumberConfig"
      :checked="previousChecked"
      :number="previouslySelectedFormatted"
      :formatted="previouslySelectedFormatted"
    ></previously-selected>

    <div class="number__wrapper_reserved" v-show="expired">
      <span
        >Unfortunately, this number has been taken. Please choose a new
        one.</span
      >
    </div>
    <number-type
      v-if="showNumberConfig"
      :product="product"
    ></number-type>

    <selected-numbers
      v-if="product === 'CleverNumbers' && $store.getters.numbersCart.length > 0"
    ></selected-numbers>
    <button class="numberBack" @click="navBack">&lt; Back</button>
    <button v-show="isValid" @click="numbersConfirm" class="numberNext">
      Continue to {{ continueButtonText }} >
    </button>
    <div>{{ errors }}</div>
  </div>
</template>

<script>
import NumberType from "./components/NumberType.vue";
import PreviouslySelected from "./components/PreviouslySelected.vue";
import SelectedNumbers from "./components/SelectedNumbers.vue";
import NumberRouter from "./components/NumberRouter.vue";
import Timeout from './components/modals/TimoutAlert.vue';
import { eventBus } from "./main";
import NumberService from "@/services/NumberService.js";
import { exportDefaultSpecifier } from "@babel/types";

function getUtm() {
  var utmkeys = [
    "utm_source",
    "utm_term",
    "utm_campaign",
    "utm_content",
    "utm_medium",
    "utm_expid",
    "gclid",
    "msclkid",
  ];
  var utmObj = {};
  Object.keys(sessionStorage).reduce(function (utmData, key) {
    var match = utmkeys.indexOf(key);
    if (match !== -1) {
      utmObj[key] = sessionStorage.getItem(key);
    }
    return utmData;
  }, {});

  return utmObj;
}

export default {
  data() {
    return {
      showNumberConfig: false,
      keepExisting: false,
      previousChecked: false,
      previouslySelectedFormatted: null,
      expired: false,
      nextStep: null,
      product: null,
      errors: null,
      expiryIntervalId: null
    };
  },
  mounted() {
    this.removeQueryString();
    this.nextStep = window.nextStep;
    this.product = window.productType;
    const numberType = window.numberType == "" ? "regional" : window.numberType.toLowerCase();
    this.$store.commit('setNumberType', numberType);
    this.$store.commit('setReceipt', this.getReceipt());
    const instance = this;

    if (this.product === "PocketPhone") {
      NumberService.getNumberStatus()
        .then((response) => {
          if (response.data.selected) {
            this.$store.commit("updatePpsNumber", response.data.selected);
            this.previouslySelectedFormatted = response.data.formatted;
            this.checkForDivertNumberSelected();
            this.previousChecked = true;
          }
          this.expired = response.data.expired;
        })
        .catch((err) => {
          this.errors = "Sorry, problem encountered retrieving number status";
        });
    } else {
      this.expiryIntervalId = setInterval(function() {
          instance.checkExpiry(); 
        }, 1500000);
        this.checkForDivertNumberSelected();
      this.refreshBasket();
    }

    eventBus.$on("number-selected", (number) => {
      if (this.product === "CleverNumbers") {
        this.cleverNumberSelected(number);
      } else {
        this.$store.commit("updatePpsNumber", number);
        this.previousChecked = false;
      }
    });

    eventBus.$on("previous-selected", (number) => {
      this.$store.commit("updatePpsNumber", number);
      this.previousChecked = true;
    });

    eventBus.$on("type-changed", (numberType) => {
      this.numberType = numberType;
    })
  },
  methods: {
    chooseNumber() {
      this.showNumberConfig = true;
      this.keepExisting = false;
      localStorage.setItem('divertNumber', 'false');
    },
    keepNumber() {
      this.keepExisting = true;
      this.showNumberConfig = false;
      localStorage.setItem('divertNumber', 'true');
    },
    checkForDivertNumberSelected() {
      var divertSelected = localStorage.getItem('divertNumber');
      
      if(divertSelected === 'true') {
        this.keepExisting = true;
        this.showNumberConfig = false;
      } else{
        this.keepExisting = false;
        this.showNumberConfig = true;
      }
    },
    numbersConfirm() {
      if (this.product === "PocketPhone") {
        this.pocketPhoneConfirm();
      }

      if(this.product === "CleverNumbers"){
        if(this.$route.name === 'NumberSelector'){
          this.$router.push({ name: 'NumberRouter'});
        } else {
          this.cleverNumbersConfirm();
        }
      }
    },
    cleverNumberSelected(number) {
      const itemInCart = this.$store.getters.numbersCart.filter(function(e) { return e.number === number; }).length > 0;
      if (!itemInCart) {
        this.$store.commit('addToCart', number);
        NumberService.reserveNumber(number, this.$store.getters.receipt)
          .then((result) => {
            if (result.data == true) {
              this.refreshBasket();
            } else {
              throw new Error(
                `Unable to reserve number: ${number}. Please try another.`
              );
            }
          })
          .catch((err) => {
            this.errors = err.message;
          });
      }
    },
    getReceipt() {
      let cookie = {};
      document.cookie.split(";").forEach(function (el) {
        let [k, v] = el.split("=");
        cookie[k.trim()] = v;
      });
      return cookie["receipt"];
    },
    removeQueryString() {
      if (location.href.includes("?")) {
        history.pushState({}, null, location.href.split("?")[0]);
      }
    },
    pocketPhoneConfirm() {
      var utmData = getUtm();
      const ppsNumber = this.$store.getters.ppsNumber;

      if (ppsNumber) {
        if(!this.keepExisting){
          NumberService.chooseNumber(ppsNumber, utmData)
          .then((res) => {
            window.location.href = res.data + "?receipt=" + this.getReceipt();
          })
          .catch((err) => {
            this.errors = err.message;
          });
        } else{
          NumberService.getNextUrl(utmData)
            .then((res) => {
              window.location.href = res.data + "?receipt=" + this.getReceipt();
            })
        }

      } else {
        NumberService.reserveDivert(utmData)
          .then((res) => {
            window.location.href = res.data + "?receipt=" + this.getReceipt();
          })
          .catch((err) => {
            this.errors = err.message;
          });
      }
    },
    cleverNumbersConfirm(){
      this.$store.commit('setSubmitted');
      
      const valid = this.$store.getters.numbersCart.every(item => {
        return item.valid === true;
      });

      if(valid){
        const utmData = getUtm();
        const receipt = this.$store.getters.receipt;
        const routes = this.$store.getters.numbersCart.map(item => ({
          number: item.number,
          destination: item.route
        }));

        NumberService.finaliseCleverNumbers(routes, utmData, receipt)
          .then((result) => {
            const routes = result.data.routes;
            const valid = routes.every(function(route) {
              return route.validRoute === true;
            });

            if(valid){
              window.location.href = result.data.forwardingUrl + "?receipt=" + this.getReceipt();;
            } else {
              routes.forEach(route => {
                this.$store.commit('updateCartValidation', { number: route.number, valid: route.validRoute });
              })
            }
          })
          .catch((err => {
            this.errors = "Error assigning numbers to route.";
          }));
      }
    },
    navBack() {
      if(this.$route.name === "NumberRouter"){
        this.$router.push({ name: 'NumberSelector', params: { routeNumberType: this.numberType } });
      } else{
        window.location.href = window.backUrl;
      }
    },
    checkExpiry() {
      if(this.$store.getters.cartExpiryDate instanceof Date) {
        const timeDifference = new Date() - this.$store.getters.cartExpiryDate;
        const minutesDifference = Math.floor(((timeDifference % 86400000) % 3600000) / 60000);

        if(this.$store.getters.numbersCart.length > 0 && minutesDifference >= 25) {
          this.showTimeoutAlert();
          this.$store.commit('refreshCartExpiry');
          clearInterval(this.expiryIntervalId);
          const instance = this;
          this.expiryIntervalId = setInterval(function() { instance.checkExpiry(); }, 1500000);
        }
      }
    },
    showTimeoutAlert() {
      this.$dlg.modal(Timeout, {
        width: 600,
        height: 300,
        title: false,
        closeButton: false,
        maxButton: false,
        shaking: false
      });
    },
    refreshBasket() {
      NumberService.getBasket(this.$store.getters.receipt).then((result) => {
        this.$store.commit('refreshCart', result.data);
      });
    },
  },
  computed: {
    isValid() {
      return Boolean(this.$store.getters.numbersCart.length > 0) || this.$store.getters.ppsNumber || this.keepExisting;
    },
    continueButtonText(){
      if(this.product === "CleverNumbers") {
        return this.$route.name === "NumberRouter" ? this.nextStep : "Routing";
      }

      return this.nextStep;
    }
  },
  components: {
    NumberType,
    PreviouslySelected,
    SelectedNumbers,
    NumberRouter,
    Timeout
  },
};
</script>
